import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ScenarioModel } from '../../Models/scenario-model';
import { StepModel } from '../../Models/step-model';
import { FeatureModel } from '../../Models/feature-model';
import { FeatureServiceService } from '../../Services/feature-service.service';
import { ScenarioServiceService } from '../../Services/scenario-service.service';
import { StepServiceService } from '../../Services/step-service.service';
import { ListInterface } from '../../Inteface/list-interface';
import { SuiteService } from '../../Services/suite.service';
import { SuiteModel } from '../../Models/suite-model';
import { Router, ActivatedRoute } from '@angular/router';
import { Literals } from '../../literals';
import { Model } from 'src/app/Models/model';
import { CucumberService } from 'src/app/Services/cucumber.service';
import { SharedService } from 'src/app/Services/shared.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';
import { AddElementComponent } from '../../AppBaseComponents/add-element/add-element.component';
import { RestService } from '../../Services/rest.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { Location } from '@angular/common';

@Component({
  selector: 'ze-library-view',
  templateUrl: './library-view.component.html',
  styleUrls: ['./library-view.component.scss']
})
export class LibraryViewComponent implements OnInit {
  public featureListInterface: ListInterface;
  public stepListInterface: ListInterface;
  public scenarioListInteface: ListInterface;
  public suiteListInterface: ListInterface;
  public tabsList: ListInterface[];
  public currentView = Literals.NONE;
  public showSuite = true;
  public showFeature = true;
  public showStep = true;
  public showScenario = true;
  public indexToOpen = 0;
  private projectId;
  public currentTabType = "";
  public currentIndex: number = 0;
  public loaderCount: number = 0;
  private cucumberSub: Subscription;
  private updating: Boolean = false;

  constructor(private featureService: FeatureServiceService,
    private scenarioService: ScenarioServiceService,
    private stepService: StepServiceService,
    public suiteService: SuiteService,
    private cucumberService: CucumberService,
    private _sharedService: SharedService,
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public rest: RestService,
    private notifys: NotifyService,
    private location: Location) {
  }

  ngOnInit() {
    this.tabsList = new Array<ListInterface>();
    this.loadView(Literals.NONE);
  }
  loadView(view: string) {

    switch (view) {
      case Literals.NONE:
        this.showStep = true;
        this.showFeature = true;
        this.showSuite = true;
        this.showScenario = true;
        this.loaderCount = 4;
        this.featureListChange();
        this.scenarioListChange();
        this.stepListChange();
        this.suiteListChange();
        break;
      case Literals.FEATURE:
        this.showStep = true;
        this.showFeature = true;
        this.showSuite = true;
        this.showScenario = true;
        this.loaderCount = 4;
        this.scenarioListChange();
        break;
      case Literals.SUITE:
        this.showStep = true;
        this.showFeature = true;
        this.showSuite = true;
        this.showScenario = true;
        this.loaderCount = 4;
        this.suiteListChange();
        this.featureListChange();
        this.scenarioListChange();
        this.stepListChange();
        break;
      case Literals.STEP:
        this.showStep = true;
        this.showFeature = true;
        this.showSuite = true;
        this.showScenario = true;
        break;
      case Literals.SCENARIO:
        this.showStep = true;
        this.showFeature = true;
        this.showSuite = true;
        this.showScenario = true;
        this.loaderCount = 4;
        this.featureListChange();
        this.scenarioListChange();
        this.stepListChange();
        this.suiteListChange();
        break;
    }
    this._sharedService.loaderHide.emit(false);

  }
  featureListChange() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCount--;
    this.featureListInterface = new ListInterface();
    this.featureService.getItems().subscribe(data => {
      var datasource = data
      this.featureListInterface.models = data['data'].filter(Boolean);
      this._sharedService.loaderHide.emit(false);
    });
    this.featureListInterface.mainHeadingName = "Feature";
    this.featureListInterface.setOnclick(this, "onFeatureSelected");
    this.featureListInterface.modelService = this.featureService;
  }
  onFeatureSelected(model: FeatureModel) {
    this.currentTabType = Literals.FEATURE;
    if (this.tabsList[this.currentIndex] != undefined)
      this.tabsList[this.currentIndex]['models'] = [];
    this.addModelToTab(model, this.featureService);
  }
  scenarioListChange() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCount--;
    this.scenarioListInteface = new ListInterface();
    this.scenarioService.getItems().subscribe(data => {
      var datasource = data
      this.scenarioListInteface.models = data['data'].filter(Boolean);;
      this._sharedService.loaderHide.emit(false);
    });
    this.scenarioListInteface.mainHeadingName = "Scenario";
    this.scenarioListInteface.setOnclick(this, "onScenarioSelected");
    this.scenarioListInteface.modelService = this.scenarioService;
  }
  onScenarioSelected(model: ScenarioModel) {
    this.currentTabType = Literals.SCENARIO;
    if (this.tabsList[this.currentIndex] != undefined)
      this.tabsList[this.currentIndex]['models'] = [];
    this.addModelToTab(model, this.scenarioService);
  }
  stepListChange() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCount--;
    this.stepListInterface = new ListInterface();
    this.stepService.getItems().subscribe(data => {
      var datasource = data
      this.stepListInterface.models = data['data'].filter(Boolean);
      this._sharedService.loaderHide.emit(false);
    });
    this.stepListInterface.mainHeadingName = "Step";
    this.stepListInterface.setOnclick(this, "onStepSelected");
    this.stepListInterface.modelService = this.stepService;
  }
  onStepSelected(model: StepModel) {
    this.router.navigate(['/step/' + model['_id']]);
  }
  suiteListChange() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCount--;
    this.suiteListInterface = new ListInterface();
    this.suiteService.getItems().subscribe(data => {
      var datasource = data
      this.suiteListInterface.models = data['data'].filter(Boolean);
      this._sharedService.loaderHide.emit(false);
    },
      error => {
        this.loaderCount--;
        this._sharedService.loaderHide.emit(false);
        throw error;
      });
    this.suiteListInterface.mainHeadingName = "Suites";
    this.suiteListInterface.setOnclick(this, "onSuiteSelected");
    this.suiteListInterface.modelService = this.suiteService;
  }
  onSuiteSelected(model: SuiteModel) {
    this.currentTabType = Literals.SUITE;
    if (this.tabsList[this.currentIndex] != undefined)
      this.tabsList[this.currentIndex]['models'] = [];
    this.addModelToTab(model, this.suiteService);
  }
  modalToList(modal, service) {
    var li = new ListInterface();
    li.models = [];
    li.mainHeadingName = modal.name;
    li._id = modal._id;
    li._type = modal._type;
    li.modelService = service;
    return li;
  }
  resetView() {
    this.loadView(Literals.NONE);
  }
  addModelToTab(model: Model, service) {
    var flag: Boolean = false;
    for (var i = 0; i < this.tabsList.length; i++) {
      if (
        (this.tabsList[i].mainHeadingName == (model as any).name) &&
        (this.tabsList[i]._type == (model as any)._type)
      ) {
        flag = true;
        this.indexToOpen = i;
        break;
      }
    };
    if (!flag) {
      this.tabsList.push(this.modalToList(model, service))
      this.indexToOpen = this.tabsList.length - 1;
    }
  }
  spliceTab(event: number) {
    this.tabsList.splice(event, 1);
  }
  selectedIndex(index: number) {
    this.currentIndex = index;
    if (index >= 0) {
      switch (this.tabsList[index].modelService.constructor.name) {
        case this.suiteService.constructor.name:
          this.showStep = true;
          this.showFeature = true;
          this.showSuite = true;
          this.showScenario = true;
          this.currentTabType = Literals.SUITE;
          break;
        case this.featureService.constructor.name:
          this.showStep = true;
          this.showFeature = true;
          this.showSuite = true;
          this.showScenario = true;
          this.currentTabType = Literals.FEATURE;
          break;
        case this.scenarioService.constructor.name:
          this.showStep = true;
          this.showFeature = true;
          this.showSuite = true;
          this.showScenario = true;
          this.currentTabType = Literals.SCENARIO;
          break;
        case this.stepService.constructor.name:
          this.showStep = true;
          this.showFeature = true;
          this.showSuite = true;
          this.showScenario = true;
          this.currentTabType = Literals.STEP;
          break;
        default:
          this.showStep = true;
          this.showFeature = true;
          this.showSuite = true;
          this.showScenario = true;
          this.currentTabType = Literals.NONE;
      }
      this.getCurrentCucumber();
    }
  }
  resequence(array) {
    let array2 = JSON.parse(JSON.stringify(array))
    for (let index = 0; index < array2.length; index++) {
      array2[index].model['seq_no'] = index;
    }
    return array2
  }
  mapper(eve) {
    let eve2 = [];
    for (let index = 0; index < eve.length; index++) {
      eve2.push({ _type: eve[index].model._type, model: eve[index].model._id })
    }
    return eve2;
  }
  updateCanvas(eve) {
    this._sharedService.loaderHide.emit(true);
    this.updating = true;
    eve = this.resequence(eve.model);
    eve.map((m1) => { m1.seq_no = m1.model.seq_no; m1.model = m1.model._id })
    switch (this.currentTabType) {
      case Literals.SUITE:
        this.cucumberService.addNewInSuite(this.tabsList[this.currentIndex]._id, eve).subscribe(data => {
          this.getCurrentCucumber();
        });
        break;
      case Literals.FEATURE:
        this.cucumberService.addNewInFeature(this.tabsList[this.currentIndex]._id, eve).subscribe(data => {
          this.getCurrentCucumber();
        });
        break;
      case Literals.SCENARIO:
        this.cucumberService.addNewInScenario(this.tabsList[this.currentIndex]._id, eve).subscribe(data => {
          this.getCurrentCucumber();
        });
        break;
    }
  }
  getCurrentCucumber() {
    if (this.currentIndex >= 0)
      switch (this.currentTabType) {
        case Literals.SUITE:
          if (this.cucumberSub)
            this.cucumberSub.unsubscribe();
          if (this.tabsList[this.currentIndex]['model'] == undefined || this.updating) {
            this.updating = false;
            this._sharedService.loaderHide.emit(true);
            this.cucumberSub = this.cucumberService.getSuiteCucumber(this.tabsList[this.currentIndex]._id).subscribe(data => {
              this._sharedService.loaderHide.emit(false);
              if (data.data != undefined) {
                this.tabsList[this.currentIndex]['model'] = data.data;
              }
            });
            this.suiteListChange();
          } break;
        case Literals.FEATURE:
          if (this.cucumberSub)
            this.cucumberSub.unsubscribe();
          if (this.tabsList[this.currentIndex]['model'] == undefined || this.updating) {
            this.updating = false;
            this._sharedService.loaderHide.emit(true);
            this.cucumberSub = this.cucumberService.getFeatureCucumber(this.tabsList[this.currentIndex]._id).subscribe(data => {
              this._sharedService.loaderHide.emit(false);
              if (data.data != undefined) {
                this.tabsList[this.currentIndex]['model'] = data.data;
              }
            });
            this.featureListChange();
          } break;
        case Literals.SCENARIO:
          if (this.cucumberSub)
            this.cucumberSub.unsubscribe();
          if (this.tabsList[this.currentIndex]['model'] == undefined || this.updating) {
            this.updating = false;
            this._sharedService.loaderHide.emit(true);
            this.cucumberSub = this.cucumberService.getScenarioCucumber(this.tabsList[this.currentIndex]._id).subscribe(data => {
              this._sharedService.loaderHide.emit(false);
              if (data.data != undefined) {
                this.tabsList[this.currentIndex]['model'] = data.data;
              }
            });
            this.scenarioListChange();
          } break;
        case Literals.STEP:
          break;
      }
  }
  deleteCucumberModel_bak(event) {
    this._sharedService.loaderHide.emit(true);
    this.cucumberService.delete(this.tabsList[this.currentIndex]._id, event._id).subscribe((data) => {
      this._sharedService.loaderHide.emit(false);
      this.updating = true;
      this.getCurrentCucumber();
    });
  }
  deleteCucumberModel(event) {
    for (let i = 0; i < this.tabsList[this.currentIndex]['model'].length; i++) {
      if (this.tabsList[this.currentIndex]['model'][i]._id == event._id) {
        this.tabsList[this.currentIndex]['model'][i].deleted = 1;
      }
    }
  }

  saveAsModel(event:any) {
    try{
    this.updating = true;
    console.log(event);
    let dialogRef = this.dialog.open(AddElementComponent,
      {
        data: {
          event: event,
          title: "Save As",
          name: event.mainHeadingName+" Copy"
        }
      });
      dialogRef.afterClosed().subscribe(result=>{
        if (result) {
          this._sharedService.loaderHide.emit(true)
        console.log("Dialog clodsed with the result:",result);
        let projectId = localStorage.getItem("projectId");
        let existingArtifactId = event._id;
        event = this.resequence(event.model);
        event.map((m1) => { m1.seq_no = m1.model.seq_no; m1.model = m1.model._id })
            if(this.currentTabType==Literals.SUITE){
              console.log("SUITE");
            var data =this.dataCreatorsuite(projectId, existingArtifactId, result.name,event);
            console.log(data);
            return this.rest.put('copysuite',data).subscribe( response => {
              console.log("Response from saveassuite:", response);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "Updated Successfully");
              this.location.go(this.location.path());
              window.location.reload();
            },
            error => {
              console.error("Error in saveassuite:", error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', error);
            }); 
        }  
        else if(this.currentTabType==Literals.FEATURE){
          console.log("FEATURE");
            var data1 =this.dataCreatorfeature(projectId, existingArtifactId, result.name,event);
            console.log(data1);
            return this.rest.put('copyfeature',data1).subscribe( response => {
              console.log("Response from saveassuite:", response);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "Updated Successfully");
              this.location.go(this.location.path());
              window.location.reload();
            },
            error => {
              console.error("Error in saveassuite:", error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', error);
            });
        }
        else{
          console.log("SCENARIO");
            var data2 =this.dataCreatorscenario(projectId, existingArtifactId, result.name,event);
            console.log(data2);
            return this.rest.put('copyscenario',data2).subscribe( response => {
              console.log("Response from saveassuite:", response);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "Updated Successfully");
              this.location.go(this.location.path());
              window.location.reload();
            },
            error => {
              console.error("Error in saveassuite:", error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', error);
            }); 
        }
      }
      });

    
  }catch(e){

  }
}

dataCreatorsuite(projectId, id, name, datamodel){
  return {
    project: { _id: projectId },
    suite: {_id: id, name: name, type:"suite"},
    cucumbers : datamodel
  };
}
dataCreatorfeature(projectId, id, name,datamodel){
  return {
    project: { _id: projectId },
    feature: {_id: id, name: name, type:"feature"},
    cucumbers : datamodel
  };
}
dataCreatorscenario(projectId, id, name, datamodel){
  return {
    project: { _id: projectId },
    scenario: {_id: id, name: name, type:"scenario"},
    cucumbers : datamodel
  };
}

}